<template>
  <div
    class="main-content main-conent-maxheight main-content-rows page-home screen"
    :class="{ fullScreen: isFullScreen }"
  >
    <div class="home-head">
      <div class="title">农作物病虫害自动监测预警平台</div>
      <n-time></n-time>
    </div>

    <div class="main-rows">
      <div class="main-col main-left">
        <tele :dev-key="site.devices.lamp"></tele>
      </div>

      <div class="main-col main-body">
        <div class="device-map-wrap" style="height: 60%;">
          <n-map :dev-key="site.devices.lamp"></n-map>
        </div>

        <card style="height: 40%;" direction="row">
          <!-- <camera :dev-key="site.devices.cameras[0]"></camera> -->
          <air :code="site.devices.air"></air>
        </card>
      </div>

      <div class="main-col main-right">
        <mete :weather-key="site.devices.weather"></mete>
      </div>
    </div>
  </div>
</template>

<script>
import NMap from './components/map'
import Tele from './components/tele/index'
import Mete from './components/mete/index'
import Air from './components/air/index'
import Card from './components/card'
import NTime from '@/views/Homes/components/time'
import { getJson } from '@/service/site'

export default {
  components: { NTime, Tele, NMap, Mete, Card, Air },
  name: 'Home',
  data() {
    return {
      centerType: 'map',
      clone: null,
      isFullScreen: false,
      site: { devices: { air: '', lamp: '', weather: '', cameras: [] } }
    }
  },
  async mounted() {
    this.$el.onfullscreenchange = this.exitFullScreen
    const sites = this.getSites(this.companyId)
    this.site = sites ? sites[0] : {}
  },
  methods: {
    async getSites(id) {
      try {
        const sites = await getJson(id)
        return sites
      } catch (e) {
        console.log(e)
        return []
      }
    },
    fullScreen() {
      this.$el.requestFullscreen()
    },
    exitFullScreen() {
      this.isFullScreen = !this.isFullScreen
    },
    siteChange(site) {
      this.site = site
    }
  }
}
</script>

<style lang="scss">
$--head-title-height: 40px;
$--title-font: 12px;
$--sub-font: 8px;

.page-home.screen {
  background-image: url('~@/assets/images/dashboard-bg.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  font-size: $--sub-font;
  display: flex;
  flex-direction: column;
  align-items: center;
  .amap-logo,
  .amap-copyright {
    display: none !important;
  }
  .home-map-btn-group {
    position: absolute;
    top: 8px;
    left: 80px;
    z-index: 100;
    .el-button {
      background-color: rgba(51, 53, 56, 1);
      border: #656565;
      &.is-disabled {
        background-color: rgba(51, 53, 56, 0.7);
        color: #9aa8d4;
      }
    }
  }
  .device-map-wrap {
    position: relative;
    padding-bottom: 12px;
    box-sizing: border-box;
  }
  .home-head {
    height: $--head-title-height;
    width: 90%;
    text-align: center;
    background-image: url('~@/assets/images/title-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    .title {
      font-size: $--title-font;
      letter-spacing: 0;
      line-height: $--head-title-height - 10px;
      text-align: center;
    }
    .time {
      position: absolute;
      right: 4px;
      top: $--head-title-height / 3;
      font-size: $--sub-font;
    }
  }
  .main-col {
    margin: 0 $--sub-font;
    .home-card:not(:last-child) {
      // margin-bottom: 40px;
    }
  }
  .el-table {
    border: none;
    box-shadow: none;
  }
  .main-rows {
    height: calc(100% - 50px);
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  .main-left,
  .main-right,
  .main-body {
    display: flex;
    flex-direction: column;
  }
  .main-left,
  .main-right {
    // flex: 1;
    width: 25%;
  }
  .main-body {
    flex: 2;
  }
}
</style>
